/* eslint-disable @typescript-eslint/no-explicit-any */
import { type searchParam } from '@/hooks/useCategoryHook'
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { Disclosure, Transition } from '@headlessui/react'
import { useState, type Dispatch, type SetStateAction } from 'react'
import { FilterGroup } from './FilterGroup'

export interface FilterList {
  className?: string
  filterGroup: Property
  title?: string
  currentFilter?: searchParam[]
  setCurrentFilter?: Dispatch<SetStateAction<searchParam[]>>
  onChange: (params: any, routerChange?: boolean) => void
  activeFilters: {
    name: string
    values: string[]
  }[]
}

export const FilterList = ({
  title,
  className,
  filterGroup,
  activeFilters = [],
  onChange = () => true,
}: FilterList) => {
  const [isReadMore, setIsReadMore] = useState(true)
  const [isPropertyFilter, setIsPropertyFilter] = useState(8)

  const toggleReadMore = () => {
    setIsPropertyFilter(isReadMore ? 99 : 8)
    setIsReadMore(!isReadMore)
  }

  return (
    <div className={`${className ? className : ''}`}>
      <Disclosure defaultOpen={true}>
        {({ open }) => (
          <>
            <Disclosure.Button>
              <p className='text-sm font-semibold mb-2 text-dark-400'>
                {title}
              </p>
            </Disclosure.Button>
            <Transition
              show={open}
              enter='transition duration-100 ease-out'
              enterFrom='transform scale-95 opacity-0'
              enterTo='transform scale-100 opacity-100'
              leave='transition duration-75 ease-out'
              leaveFrom='transform scale-100 opacity-100'
              leaveTo='transform scale-95 opacity-0'
            >
              <Disclosure.Panel className={'mt-1'}>
                <div
                  className={`filterContent grid h-full grid-cols-2 gap-x-2 items-start overflow-hidden `}
                >
                  {filterGroup.values.length > 0 &&
                    filterGroup.values
                      .slice(0, isPropertyFilter)
                      .map((t, index) => (
                        <FilterGroup
                          type='checkbox'
                          className='mb-1'
                          key={`group-${index}`}
                          option={t}
                          activeOption={activeFilters.find(
                            (f: any) => f.name === getPath(filterGroup.slugs)
                          )}
                          onChange={e => onChange(e, false)}
                        >
                          <span className='block h-full align-super text-sm text-dark-400'>
                            {getTranslate(t.value)}
                          </span>
                        </FilterGroup>
                      ))}
                </div>
                {filterGroup.values.length > 8 && (
                  <span
                    onClick={toggleReadMore}
                    className='readOrHide cursor-pointer mt-1 text-xs text-primary-base gap-x-2 flex items-center'
                  >
                    {isReadMore ? 'Hiển thị nhiều hơn' : 'Hiển thị ít hơn'}

                    <svg
                      className={`inline-block origin-center ${
                        !isReadMore ? 'rotate-180' : ''
                      }`}
                      width='9'
                      height='7'
                      viewBox='0 0 9 7'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.0575 0.328186L-2.12363e-07 1.46989L4.5 6.32819L9 1.46989L7.9425 0.328186L4.5 4.03669L1.0575 0.328186Z'
                        fill='#FF4B32'
                      />
                    </svg>
                  </span>
                )}
              </Disclosure.Panel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  )
}
